import Container from './ReactionsDisplay.container';
import ReactionsDisplay from './ReactionsDisplay';
export default Container(ReactionsDisplay);
//# sourceMappingURL=index.js.map